// API Client - JavaScript versiyonu
import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../constants/api';

// Token yönetimi
export const tokenManager = {
  setToken: (token) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    }
  },

  getToken: () => {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem(STORAGE_KEYS.TOKEN);
    }
    return null;
  },

  removeToken: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
    }
  },

  setUser: (user) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    }
  },

  getUser: () => {
    if (typeof localStorage !== 'undefined') {
      const user = localStorage.getItem(STORAGE_KEYS.USER);
      return user ? JSON.parse(user) : null;
    }
    return null;
  },

  clearAll: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
    }
  },
};

// Axios instance
export const createApiClient = () => {
  const api = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: API_CONFIG.TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request interceptor - token ekle
  api.interceptors.request.use(
    (config) => {
      const token = tokenManager.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - hata yönetimi
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      // 401 Unauthorized - token expire olmuş
      if (error.response?.status === 401) {
        tokenManager.removeToken();
        if (typeof window !== 'undefined') {
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    }
  );

  return api;
};

export const apiClient = createApiClient();
